import React from "react";
import Typography from "@material-ui/core/Typography";

const H2 = (props: any) => (
  <Typography variant="h2" component="h2" gutterBottom {...props} />
);

export default H2;
